import { render, staticRenderFns } from "./editClaimType.vue?vue&type=template&id=3832caa9&scoped=true"
import script from "./editClaimType.vue?vue&type=script&lang=js"
export * from "./editClaimType.vue?vue&type=script&lang=js"
import style0 from "./editClaimType.vue?vue&type=style&index=0&id=3832caa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3832caa9",
  null
  
)

export default component.exports